<template>
  <!-- <b-col v-if="file" cols="12" md="4">
    <b-card no-body class="overflow-hidden">
      <b-row no-gutters class="p-2 b-height">
        <b-col cols="6" md="6" class="d-flex bg-lightgray">
          <div class="card-main-img">
            <b-card-img
              :src="getImg(file)"
              alt="Image"
              class="square_image"
              :class="
                pathOr(null, ['attachment_type', 'id'], file) === 10
                  ? 'object__fit--cover'
                  : 'object__fit--contain'
              "
            >
            </b-card-img>
          </div>
        </b-col>
        <b-col cols="6" md="6" class="px-1 text-right">
          <div class="text-name">{{ spliceName(file.name) }}</div>
          <div class="text-size">
            {{ bytesToSize(file.size) }}
            <span v-if="file.ext">| {{ file.ext }}</span>
          </div>
          <div class="btn-style">
            <span
              class="
                width_32
                height_32
                bg-light
                rounded-circle
                d-flex
                align-items-center
                justify-content-center
                cursor_pointer
                text-dark
              "
              @click="removeFile(file)"
            >
              <i class="fa fa-trash" />
            </span>
          </div>
        </b-col>
      </b-row>
      <b-progress
        v-if="progress"
        :value="progress"
        show-progress
        :animated="progress == 100 ? false : true"
      ></b-progress>
    </b-card>
  </b-col> -->
  <b-col cols="12" md="6" lg="4">
    <b-card no-body class="overflow-hidden">
      <b-row align-v="start" align-h="between" class="p-2 mx-0">
        <b-col cols="auto" md="auto" class="bg-light rounded text-center px-0">
          <b-card-img
            :src="getImg(file)"
            alt="Image"
            class="square_image"
            :class="
              pathOr(null, ['attachment_type', 'id'], file) === 10
                ? 'object__fit--cover'
                : 'object__fit--contain'
            "
          />
        </b-col>
        <b-col cols="auto" md="" class="px-1 text-right">
          <span class="text-name">{{ spliceName(file.name) }}</span>
          <div class="text-size dir_ltr">
            <span v-if="file.size">{{ bytesToSize(file.size) }}</span>
            <span v-if="file.ext">| {{ file.ext }}</span>
          </div>
        </b-col>
      </b-row>
      <b-row align-v="center" align-h="center" class="m-0 p-0 w-100 border-top">
        <b-col class="px-2">
          <b-progress
            v-if="progress"
            :value="progress"
            show-progress
            :animated="progress !== 100"
          />
        </b-col>
        <b-col cols="auto" sm="auto" md="auto" class="p-2">
          <span
            class="width_32 height_32 bg-light rounded-circle d-flex align-items-center justify-content-center cursor_pointer text-dark"
            @click="removeFile(file)"
          >
            <i class="fa fa-trash" />
          </span>
        </b-col>
      </b-row>
    </b-card>
  </b-col>
</template>

<script>
import { pathOr } from "ramda";

export default {
  name: "file-progress",
  inject: ["attachmentTempRepository"],
  data() {
    return {
      progress: 0,
    };
  },
  props: {
    allowFileSize: {
      type: Number,
      default: null,
    },
    file: {
      type: [Object, File],
    },
    keyServies: {
      type: [String, Number],
      default: "",
    },
    keyValue: {
      type: [String, Number],
      default: "",
    },
    attachmentTypeId: {
      type: [String, Number],
      default: null,
    },
  },
  created() {
    this.saveAttachmentTemp();
  },
  methods: {
    pathOr,
    spliceName(name) {
      if (name) return name.split(".")[0];
    },
    bytesToSize(bytes, seperator = "") {
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "n/a";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return `${bytes}${seperator}${sizes[i]}`;
      return `${(bytes / 1024 ** i).toFixed(1)}${seperator}${sizes[i]}`;
    },
    getImg(file) {
      const fileType = file.type;
      const fileName = file.name.split(".")[1]; // get file by suffix name
      return fileType.match("image")
        ? URL.createObjectURL(file)
        : `/img/shared/file-icon/${fileName}.svg`;
    },
    async saveAttachmentTemp() {
      try {
        let formData = new FormData();
        formData.append("image", this.file);
        formData.append("attachment_type_id", this.attachmentTypeId);
        const response = await this.attachmentTempRepository.create(
          formData,
          {
            "Content-Type": "multipart/form-data",
          },
          true,
          {
            onUploadProgress: function (e) {
              this.progress = parseInt(Math.round((e.loaded * 100) / e.total));
            }.bind(this),
          }
        );

        let responseCode = {
          code: response.data.data.code,
          name: response.data.data.name,
          type: response.data.data.type,
        };
        this.$emit("saveAttachmentTemp", responseCode);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.BtnProgressSend = false;
        this.progressbar = true;
      }
    },
    removeFile(id) {
      this.$emit("removeFile", id);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-name {
  font-size: 12px;
  max-width: 12rem;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  direction: ltr;
  text-overflow: ellipsis;
}

.text-date {
  font-size: 11px;
  padding: 0 4px;
  color: #999;
}

.text-size {
  font-size: 11px;
  padding: 0 4px;
  color: #888;
}
</style>
